import React from "react";
import BioChemTab from "../Containers/Tabs/BioChemTab";
import ChemistryTab from "../Containers/Tabs/ChemistryTab";
import BatchReportTab from "../Containers/Tabs/BatchReportTab";
import MicroTab from "../Containers/Tabs/MicroTab";
import DashboardTab from "../Containers/Tabs/DashboardTabs";
import DataOpsAnalyticsTab from "../Containers/Tabs/DataOpsAnalyticsTab";
import PcrTab from "../Containers/Tabs/PcrTab";
// import SendReportsTab from "../Containers/Tabs/SendReportsTab";
import LogViewer from "../Containers/Components/LogViewer/LogViewer";
import Migrate from "../Containers/Components/Migrate/Migrate";
import Invoice from "../Containers/Components/Invoice/Invoice";
import QcTab from "../Containers/Tabs/QcTab";
// Icons
import PCRIcon from "../assets/images/overhaul/icons/PCRIcon.svg";
import BatchReportIcon from "../assets/images/overhaul/icons/BatchReportIcon.svg";
import ReportIcon from "../assets/images/overhaul/icons/ReportIcon.svg";
import DataOpsAnalyticsIcon from "../assets/images/overhaul/icons/DataOpsAnalyticsIcon.svg";
import BiochemistryIcon from "../assets/images/overhaul/icons/BioChemistryIcon.svg";
import ChemistryIcon from "../assets/images/overhaul/icons/ChemistryIcon.svg";
import MicroIcon from "../assets/images/overhaul/icons/MicroIcon.svg";
import LogViewerIcon from "../assets/images/overhaul/icons/LogViewerIcon.svg";
import MigrateIcon from "../assets/images/overhaul/icons/MigrateIcon.svg";
import { ReactComponent as DashboardIcon } from "../assets/images/overhaul/icons/DashboardIcon.svg";
import { getUser } from "./helpers";
import SendReportsServerTab from "../Containers/Tabs/SendReportsServerTab";
import ReportDelayTab from "../Containers/Tabs/ReportDelayTab";
import AIAnalyticsPage from "../Containers/Components/AIAnalytics/AIAnalyticsPage";

/** BiochemistryIcon: https://www.svgrepo.com/svg/487874/syringe
 * InLineIcon: https://www.svgrepo.com/svg/486709/label
 * RetestIcon: https://www.svgrepo.com/svg/450283/redo-s
 */

export const defaultRoutes = [
  {
    key: "dashboard", sidebarLabel: "Dashboard", sidebarIcon: <DashboardIcon className="SideBar__DashboardIcon" />, permission: "view_automation_dashboard", path: ["/dashboard", "/dashboard/customers", "/dashboard/activity", "/dashboard/instrument", "/dashboard/ml-routing", "/dashboard/esv-retest-actions"], component: DashboardTab,
  },
  {
    key: "data-ops-analytics",
    sidebarLabel: "Data Ops",
    sidebarIcon: DataOpsAnalyticsIcon,
    permission: "view_data_ops_dashboard",
    path: [
      "/data-ops-analytics",
      "/data-ops-analytics/overdue",
      "/data-ops-analytics/retest",
      "/data-ops-analytics/rca",
    ],
    component: DataOpsAnalyticsTab,
  },
  {
    key: "ai-analytics", sidebarLabel: "AI Analytics", sidebarIcon: ReportIcon, permission: "view_ai_analytics", path: "/ai-analytics", component: AIAnalyticsPage,
  },
  {
    key: "micro", sidebarLabel: "Micro", sidebarIcon: MicroIcon, permission: "view_automation_micro", path: ["/micro", "/micro/generatesheets", "/micro/uploadsheets", "/micro/history", "/micro/pending", "/micro/hold", "/micro/scanner", "/micro/pending-queue", "/micro/discrepancy"], component: MicroTab,
  },
  {
    key: "chemistry", sidebarLabel: "Chemistry", sidebarIcon: ChemistryIcon, permission: "view_automation_chemistry", path: ["/chemistry", "/chemistry/uploaddata", "/chemistry/pending", "/chemistry/platemap", "/chemistry/mrl", "/chemistry/sequence"], component: ChemistryTab,
  },
  {
    key: "biochem", sidebarLabel: "Biochemistry", sidebarIcon: BiochemistryIcon, permission: "view_automation_biochemistry", path: ["/biochem", "/biochem/hmc", "/biochem/pending"], component: BioChemTab,
  },
  {
    key: "pcr", sidebarLabel: "PCR", sidebarIcon: PCRIcon, permission: "view_pcr", path: ["/pcr", "/pcr/starletpcr", "/pcr/manualpcr"], component: PcrTab,
  },
  {
    key: "qc", sidebarLabel: "QC", sidebarIcon: LogViewerIcon, permission: "view_qc", path: ["/qc", "/qc/dashboard", "/qc/history", "/qc/rules"], component: QcTab,
  },
  {
    key: "batchreports", sidebarLabel: "Batch Reports", sidebarIcon: BatchReportIcon, permission: "view_batchreports", path: ["/batchreports", "/batchreports/workorders", "/batchreports/mrl"], component: BatchReportTab,
  },
  // {
  //   key: "sendreports", sidebarLabel: "Send Reports", sidebarIcon: ReportIcon, permission: "view_sendreports", path: ["/sendreportsold", "/sendreportsold/upload", "/sendreportsold/available", "/sendreportsold/history", "/sendreportsold/pending"], component: SendReportsTab,
  // },
  {
    key: "sendreports", sidebarLabel: "Send Reports", sidebarIcon: ReportIcon, permission: "view_sendreports", path: ["/sendreports", "/sendreports/upload", "/sendreports/available", "/sendreports/history", "/sendreports/pending"], component: SendReportsServerTab,
  },
  {
    key: "report-delays", sidebarLabel: "Report Delay", sidebarIcon: ReportIcon, permission: "view_report_delay", path: "/report-delays", component: ReportDelayTab,
  },
  {
    key: "migrate", sidebarIcon: MigrateIcon, sidebarLabel: "Migrate", permission: "view_migrate", path: "/migrate", component: Migrate,
  },
  {
    key: "invoice", sidebarIcon: ReportIcon, sidebarLabel: "Invoice", permission: "view_invoice", path: "/invoice", component: Invoice,
  },
  {
    key: "logs", sidebarLabel: "Logs", sidebarIcon: LogViewerIcon, permission: "view_logs", path: "/logs", component: LogViewer,
  },
];

export const getAuthorizedRoutes = () => {
  const user = getUser();
  return defaultRoutes.reduce((acc, route) => {
    let hasPermission = user.permissionMap?.[route.permission];
    const hardcodeTabs = ["legacy-batchreports", "legacy-sendreports"];
    if (hardcodeTabs.includes(route.key) && user.role === 1) {
      hasPermission = true;
    }
    if (hasPermission) {
      acc.push(route);
    }
    return acc;
  }, []);
};
